import {
  Component,
  OnInit,
  ElementRef
} from '@angular/core';

import { D3Service } from '../../shared';

import * as d3 from 'd3';

@Component({
  selector: '[awair-y-axis]',
  templateUrl: './y-axis.component.html',
  styleUrls: ['./y-axis.component.scss']
})
export class YAxisComponent implements OnInit {

  constructor(
    private el: ElementRef,
    private d3Service: D3Service) { }

  ngOnInit() {
  }

  update(width: number, height: number, yScale: any, yMin: number, yMax: number) {
    if (width !== null && height !== null && yScale && yMin !== null && yMin !== Infinity && yMax !== null && yMax !== -Infinity) {

      const yAxis = this.d3Service.getAxisY(yScale, height, undefined, -width);
      yAxis.tickValues(this.getTicksY(yMin, yMax, 5));

      d3.select(this.el.nativeElement)
        .attr('class', 'y-axis')
        .call(yAxis);

      d3.select(this.el.nativeElement)
        .selectAll('.y-axis g.tick line')
        .attr('x2', (d: any) => {
          return d === yMax ? 0 : width;
        });
    }
  }

  private getTicksY(yMin: number, yMax: number, ticks: number): number[] {
    const ticksY = [];
    ticksY.push(yMin);

    const target = yMax - yMin;
    const divider = ticks - 1;
    const inc = Math.round((target / divider) * 10) / 10;

    for (let i = 1; i < divider; i++) {
      ticksY.push((yMin + (i * inc)));
    }
    ticksY.push(yMax);

    return ticksY;
  }

}
